import { motion } from "framer-motion";
import { Users, Lightning, Crown, Heart, ChatTeardrop, Trophy } from "@phosphor-icons/react";
import { PageHeader } from "../components/PageHeader";
import { About } from "../components/About";
import { PhotoStrip } from "../components/PhotoStrip";

const stats = [
    { icon: Users, label: "Community", value: "Growing", sub: "Every single night" },
    { icon: Lightning, label: "Stream energy", value: "Chaotic", sub: "Unpredictable by design" },
    { icon: Crown, label: "Dream goal", value: "Top 50", sub: "On Twitch · the long game" },
    { icon: Heart, label: "Inspired by", value: "NickEh30", sub: "Day-one role model" },
    { icon: ChatTeardrop, label: "Origin", value: "ooll56", sub: "→ ool → itz_ool" },
    { icon: Trophy, label: "Biggest win", value: "Lessons", sub: "Bigger than numbers" },
];

export const AboutPage = () => {
    return (
        <div data-testid="about-page">
            <PageHeader
                eyebrow="The Origin Story"
                title="From a random username to"
                accent="a whole community."
                intro="The short version: one weird name, one inspiration, one chat that wouldn't quit. The long version is below."
                breadcrumbs={[{ label: "Home", href: "/" }, { label: "About" }]}
            />

            <About />

            <PhotoStrip />

            <section className="relative py-10 lg:py-14" data-testid="about-stats-section">
                <div className="max-w-5xl mx-auto px-6 lg:px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className="mb-8"
                    >
                        <span className="eyebrow">Quick facts</span>
                        <h2 className="font-display text-3xl text-white mt-2">
                            Stuff worth knowing
                        </h2>
                    </motion.div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                        {stats.map((s, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: i * 0.06 }}
                                className="rounded-2xl border border-white/10 bg-obsidian-900/60 p-5 card-tilt"
                                data-testid={`stat-card-${i}`}
                            >
                                <div className="flex items-center justify-between mb-6">
                                    <div className="h-10 w-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                                        <s.icon size={16} className="text-brand-cyan" weight="fill" />
                                    </div>
                                    <span className="text-[10px] font-mono uppercase tracking-[0.25em] text-white/25">0{i + 1}</span>
                                </div>
                                <div className="eyebrow">{s.label}</div>
                                <div className="font-display text-xl text-white mt-1">{s.value}</div>
                                <div className="text-xs text-white/50 mt-1">{s.sub}</div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};
